







































































































































































import Engine, {
  Expansion,
  Faction,
  MAX_SATELLITES,
  Player,
  PlayerData,
  ResearchField,
  Resource as ResourceEnum,
} from "@gaia-project/engine";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { FastConversionEvent, MapMode, MapModeType } from "../../data/actions";
import { factionName } from "../../data/factions";
import { researchColor } from "../../data/research";
import { showIncome } from "../../data/resources";
import { leechNetwork, sectors } from "../../data/stats";
import { CellStyle } from "../../graphics/colors";
import Resource from "../Resource.vue";
import Undo from "../Resources/Undo.vue";
import VictoryPoint from "../Resources/VictoryPoint.vue";

@Component({
  components: {
    Resource,
    VictoryPoint,
    Undo,
  },
})
export default class PlayerBoardInfo extends Vue {
  @Prop()
  faction: Faction;

  @Prop()
  data: PlayerData;

  @Prop()
  height: number;

  @Prop()
  player: Player;

  get engine(): Engine {
    return this.$store.state.data;
  }

  get isFrontiers() {
    return this.engine.expansions == Expansion.Frontiers;
  }

  get researchFields(): number {
    return ResearchField.values(this.engine.expansions).length;
  }

  get canUndo() {
    return this.$store.getters.canUndo && this.engine.currentPlayer == this.player.player;
  }

  get factionName(): string {
    return factionName(this.faction);
  }

  convert(resource: ResourceEnum) {
    this.$store.dispatch("fastConversionClick", { button: resource } as FastConversionEvent);
  }

  toggleMapMode(mode: MapModeType) {
    this.$store.commit("toggleMapMode", { type: mode, player: this.player.player } as MapMode);
  }

  convertTooltip(resource: ResourceEnum): string | null {
    if (this.engine.currentPlayer == this.player.player) {
      return this.$store.state.context.fastConversionTooltips[resource];
    }
  }

  get buttonTooltip() {
    return (
      "<ul>" +
      "<li>Click on the faction name to see the faction rules (and there's a dropdown to see all faction rules)</li>" +
      "<li>Click on the buildings to see their cost, income, and power value</li>" +
      "<li>Click on the resources to get an additional resource of this kind (using the best conversion available)</li>" +
      "<li>Click on the power bowls to gain (area 1) or burn (area 3) tokens (the gaia area has faction dependent actions)</li>" +
      "<li>Click on the planets to highlight all planets of this type</li>" +
      "<li>Click on the sectors icon to highlight all colonized sectors (also works for other players)</li>" +
      "<li>Click on the federation icon to highlight all federation (also works for other players)</li>" +
      "<li>Click on the network icon (right of power bowl) to leech network - how much power can be gained if other players upgrade buildings</li>" +
      (this.isFrontiers ? "<li>Click on the trade bonus or cost icons to see the trade rewards table</li>" : "") +
      "</ul>"
    );
  }

  income(resource: ResourceEnum) {
    return this.player.resourceIncome(resource);
  }

  get showIncome() {
    return showIncome(this.engine, this.player);
  }

  researchClass(index: number): string {
    return this.$store.getters.researchClasses.get(this.player.faction)?.get(this.researchType(index)) ?? "";
  }

  researchType(index: number): ResearchField {
    return ResearchField.values(this.engine.expansions)[index];
  }

  research(index: number): number {
    return this.data.research[this.researchType(index)];
  }

  researchStyle(index: number): CellStyle {
    return researchColor(this.researchType(index));
  }

  get sectors(): number {
    return sectors(this.player);
  }

  get satellitesLeft(): number {
    return MAX_SATELLITES - this.data.satellites;
  }

  get leechNetwork(): number {
    return leechNetwork(this.engine, this.player.player);
  }
}
